import { useTranslation } from 'react-i18next'

import { EyeIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { ScrollableTabs } from '@reveni-io/reveni-ui'

import CopyDefaultText from './CopyDefaultText/CopyDefaultText'
import CopyInput from './CopyInput/CopyInput'
import CopyTitle from './CopyTitle/CopyTitle'
import CustomCopySkeleton from './CustomCopySkeleton/CustomCopySkeleton'
import useCustomCopy from './hooks/useCustomCopy/useCustomCopy'
import * as Styles from './styles'

const CustomCopy = ({
  copy,
  lang,
  onChangeCopy,
  supportedLanguages,
  customCopies,
  isCustomCopyActive,
  onChangeIsActive,
  errors,
  merchantInfo,
  activePreview,
  onPreviewChange,
  onLanguageChange,
  loading,
}) => {
  const { t } = useTranslation()
  const {
    availableLanguages,
    handleUseCustomCopy,
    onChangeTextarea,
    selectedCopyLanguage,
    isPreviewActive,
    handlePreviewClick,
    handleLanguageChange,
  } = useCustomCopy({
    onChangeIsActive,
    onChangeCopy,
    copy,
    lang,
    supportedLanguages,
    errors,
    activePreview,
    onPreviewChange,
    onLanguageChange,
  })

  const theme = useTheme()

  if (loading) return <CustomCopySkeleton />

  return (
    <Styles.Container id={copy?.key} isActive={isCustomCopyActive} isPreviewActive={isPreviewActive}>
      <Styles.CopyHeader>
        <CopyTitle label={t(copy?.label(lang))} isActive={isCustomCopyActive} onCheck={handleUseCustomCopy} />
        <Styles.PreviewButton active={isPreviewActive} onClick={handlePreviewClick} aria-label="preview">
          <EyeIcon size={20} color={isPreviewActive ? theme.colors.text.inverse : undefined} />
        </Styles.PreviewButton>
      </Styles.CopyHeader>
      {isCustomCopyActive && (
        <>
          <ScrollableTabs
            value={selectedCopyLanguage}
            onChange={handleLanguageChange}
            tabs={availableLanguages?.map(language => ({ ...language, error: errors?.[language.value]?.[copy.key] }))}
          />
          <CopyInput
            copy={copy}
            selectedCopyLanguage={selectedCopyLanguage}
            customCopies={customCopies}
            onChangeCopy={onChangeCopy}
            onChangeTextarea={onChangeTextarea}
            merchantInfo={merchantInfo}
            onPreviewChange={onPreviewChange}
            onLanguageChange={onLanguageChange}
          />
        </>
      )}
      {!isCustomCopyActive && <CopyDefaultText copy={copy} lang={lang} merchantInfo={merchantInfo} />}
    </Styles.Container>
  )
}

export default CustomCopy
